
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { AsnOrderStatusSummaryModel } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import { ApiResultModel, getAsnSubscribers } from "@WhiteCap/Store/Service/OsnSubscriptionsServices/AsnSubscribersService";

export interface SubscriptionsDashboardApiParameter extends ApiParameter {
    customerId?: string;
    onError?: (message: string) => void;
    onSuccess?: (data: AsnOrderStatusSummaryModel) => void;
}
type HandlerType = CustomApiHandler<SubscriptionsDashboardApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginAsnSubscribersDataLoad"
    });

};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getAsnSubscribers(props.apiParameter.customerId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if(props.apiParameter.onSuccess) {
            const data = {
                properties: result.result.properties,
                subscribedEmails: result.result.subscribedEmails,
                count: result.result.asnOrderStatusSummary?.count,
            };
            props.apiParameter.onSuccess(data); 
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/AsnSubscriptions/AddSubscriberError",
        });
        return false;
    }
};

export const DispatchCompleteAsnSubscribersDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteAsnSubscribersDataLoad",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteAsnSubscribersDataLoad];

const loadAsnSubscribers = createHandlerChainRunner(chain, "LoadAsnSubscribers");
export default loadAsnSubscribers;
